export default __webpack_public_path__ + "static/media/create-organisation.c72051a2.png";